export default __webpack_public_path__ + "static/media/doc-title-img.cacd1619.svg";